import clsx from 'clsx'
import { forwardRef, ReactNode } from 'react'
import { TSizeAll } from 'src/types'
import styles from './FormComponentBodyUI.module.scss'

export interface FormComponentBodyUIProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  // border-radius gap padding-inline height
  /**
   * Applies `border-radius`, `gap`, `padding-inline`, and `height` styles to the component according to the specified size.
   * If not provided, the component will have no size-related styles.
   * @default `undefined`
   */
  size?: TSizeAll
  isTransparent?: boolean
  isError?: boolean
  /**
   * Controls the vertical growth behavior of the component.
   * - If `true`, the component's height will be styled using `min-height` according to the `size` prop, and `height` will be set to `0`.
   * - If `false`, the component's height will be styled using `height` according to the `size` prop.
   */
  canGrowVertically?: boolean
}

export const FormComponentBodyUI = forwardRef<HTMLDivElement, FormComponentBodyUIProps>(
  ({ children, size, isTransparent, isError, canGrowVertically, className, ...props }, ref) => (
    <div
      className={clsx(
        styles.body,
        size ? styles[size] : null,
        canGrowVertically ? styles.usesMinHeight : styles.usesHeight,
        {
          [styles.transparent]: isTransparent,
          [styles.error]: isError,
        },
        className,
        'form-component-body',
      )}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  ),
)
